/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentToSubmitType } from './DocumentToSubmitType';
import {
    DocumentToSubmitTypeFromJSON,
    DocumentToSubmitTypeFromJSONTyped,
    DocumentToSubmitTypeToJSON,
    DocumentToSubmitTypeToJSONTyped,
} from './DocumentToSubmitType';

/**
 * 
 * @export
 * @interface PalDocumentToSubmit
 */
export interface PalDocumentToSubmit {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    document_id?: string;
    /**
     * 
     */
    document_name?: string;
    /**
     * 
     */
    custom_name?: string;
    /**
     * 
     */
    type: DocumentToSubmitType;
    /**
     * 
     */
    date?: string;
    /**
     * 
     */
    is_outdated?: boolean;
    /**
     * 
     */
    source: PalDocumentToSubmitSourceEnum;
    /**
     * 
     */
    ai_page_start?: number;
    /**
     * 
     */
    ai_page_end?: number;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    access_url?: string;
    /**
     * 
     */
    is_user_excluded: boolean;
}


/**
 * @export
 */
export const PalDocumentToSubmitSourceEnum = {
    Ai: 'ai',
    Custom: 'custom',
} as const;
export type PalDocumentToSubmitSourceEnum = typeof PalDocumentToSubmitSourceEnum[keyof typeof PalDocumentToSubmitSourceEnum];


/**
 * Check if a given object implements the PalDocumentToSubmit interface.
 */
export function instanceOfPalDocumentToSubmit(value: object): value is PalDocumentToSubmit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('is_user_excluded' in value) || value['is_user_excluded'] === undefined) return false;
    return true;
}

export function PalDocumentToSubmitFromJSON(json: any): PalDocumentToSubmit {
    return PalDocumentToSubmitFromJSONTyped(json, false);
}

export function PalDocumentToSubmitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalDocumentToSubmit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'document_name': json['document_name'] == null ? undefined : json['document_name'],
        'custom_name': json['custom_name'] == null ? undefined : json['custom_name'],
        'type': DocumentToSubmitTypeFromJSON(json['type']),
        'date': json['date'] == null ? undefined : json['date'],
        'is_outdated': json['is_outdated'] == null ? undefined : json['is_outdated'],
        'source': json['source'],
        'ai_page_start': json['ai_page_start'] == null ? undefined : json['ai_page_start'],
        'ai_page_end': json['ai_page_end'] == null ? undefined : json['ai_page_end'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'access_url': json['access_url'] == null ? undefined : json['access_url'],
        'is_user_excluded': json['is_user_excluded'],
    };
}

export function PalDocumentToSubmitToJSON(json: any): PalDocumentToSubmit {
    return PalDocumentToSubmitToJSONTyped(json, false);
}

export function PalDocumentToSubmitToJSONTyped(value?: PalDocumentToSubmit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'document_id': value['document_id'],
        'document_name': value['document_name'],
        'custom_name': value['custom_name'],
        'type': DocumentToSubmitTypeToJSON(value['type']),
        'date': value['date'],
        'is_outdated': value['is_outdated'],
        'source': value['source'],
        'ai_page_start': value['ai_page_start'],
        'ai_page_end': value['ai_page_end'],
        's3_key': value['s3_key'],
        'access_url': value['access_url'],
        'is_user_excluded': value['is_user_excluded'],
    };
}

